import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  Typography
} from '@mui/material';
import React from 'react';
import JsonDiffTable from './JsonDiffTable';

const getActionColor = (action) => {
  switch (action) {
    case 'INSERT':
      return 'success';
    case 'UPDATE':
      return 'warning';
    case 'DELETE':
      return 'error';
    default:
      return 'default';
  }
};

const formatDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString();
};

export default function ChangeLogDetailsDialog({ open, log, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Change Log Details - ID: {log?.id}</DialogTitle>
      <DialogContent>
        {log && (
          <Box>
            <Box sx={{ mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Typography>
                <strong>Table:</strong> {log.table_name}
              </Typography>
              <Typography>
                <strong>Record ID:</strong> {log.record_id}
              </Typography>
              <Typography>
                <strong>Action:</strong>{' '}
                <Chip
                  label={log.action}
                  color={getActionColor(log.action)}
                  size="small"
                />
              </Typography>
              <Typography>
                <strong>Changed By:</strong> {log.changed_by || '-'}
              </Typography>
              <Typography>
                <strong>Source:</strong> {log.change_source}
              </Typography>
              <Typography>
                <strong>Created At:</strong> {formatDate(log.created_at)}
              </Typography>
            </Box>

            <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
              Data Changes
            </Typography>
            <Paper sx={{ maxHeight: 400, overflow: 'auto' }}>
              <JsonDiffTable before={log.before_data} after={log.after_data} />
            </Paper>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
